import { render, staticRenderFns } from "./MetricsAndImpact.vue?vue&type=template&id=40215dfe&scoped=true&"
import script from "./MetricsAndImpact.vue?vue&type=script&lang=js&"
export * from "./MetricsAndImpact.vue?vue&type=script&lang=js&"
import style0 from "./MetricsAndImpact.vue?vue&type=style&index=0&id=40215dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40215dfe",
  null
  
)

export default component.exports